





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Vessel } from '@/types/entities/Vessel';
import { SearchResultItem } from '@/types/SearchResultItem';
import { GET_VESSEL_IMAGE } from '@/store/vessels';
import { GET_MAKE_BY_ID } from '@/store/makes';
import { mixins } from 'vue-class-component';
import { Route } from 'vue-router';
import BoatPlaceholderImage from '@/svg/boat-placeholder.svg';
import VesselBookmark from '@/components/Vessels/VesselBookmark.vue';
import CropImageMixin from '@/mixins/crop.mixin';

@Component({
  components: { VesselBookmark, BoatPlaceholderImage }
})
export default class VesselCard extends mixins(CropImageMixin, Vue) {
  @Prop() public vessel: SearchResultItem<Vessel>;
  @Prop() public navigationRoute: Route;

  get image(): string | null {
    return this.$store.getters[GET_VESSEL_IMAGE](this.vessel);
  }

  get make(): string {
    return this.$store.getters[GET_MAKE_BY_ID](this.vessel.relationships.make.data.id).attributes.name;
  }
}
